class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
// Custom CRO: auto-close the desktop mega menu on scroll
(function () { var desktop = window.matchMedia('(min-width: 990px)'); function openMenus() { return Array.prototype.slice.call(document.querySelectorAll('header-menu')).filter(function (m) { return m.getClientRects().length > 0 && m.querySelector('details[open]'); }); } function closeAll() { openMenus().forEach(function (m) { m.close(); }); } window.addEventListener('scroll', function () { if (desktop.matches) closeAll(); }, { passive: true }); window.addEventListener('wheel', function (e) { if (!desktop.matches) return; if (!openMenus().length) return; var panel = e.target && e.target.closest ? e.target.closest('.mega-menu__content') : null; if (panel) { var down = e.deltaY > 0; if (down ? panel.scrollTop + panel.clientHeight < panel.scrollHeight - 1 : panel.scrollTop > 1) return; } closeAll(); }, { passive: true }); })();